<template>
  <div>
    <div class="section-heading">
      <h4>Frequency</h4>
      <!-- <p>Add your product details</p> -->
      <p class="w-70 mt-3">
        Choose how often you want Weavr to fetch and update data for your
        selected products. <br />
        You can select daily, weekly or monthly updates, pick the frequency that
        best fits your business needs.
      </p>
       <p class="w-70 mt-3 tw-font-[500] tw-text-primary_brand">
        <span class="tw-font-bold">Note:</span> The reports will be sent 30 minutes after the scheduled time for these features.
      </p>
    </div>

    <div class="section-heading table-scroll-wrapper mt-4">
      <table class="demo-table" v-if="Object.keys(selectedFrequency).length">
        <thead>
          <tr>
            <th>Features</th>
            <th class="d-flex justify-content-center align-items-center">
              <span>Frequency</span
              ><i
                class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                aria-hidden="true"
                :title="selectedFrequency.time_zone"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row of selectedFeatures" :key="row.feature_id">
            <td style="font-size: 14px">{{ row.feature_name }}</td>
            <td class="py-3 pl-2 text-left w-75">
              <div
                class="tw-w-[95%] tw-flex"
              >
                <div>
                  <div
                    v-for="(freq, freqIndex) in selectedFrequency[
                      row.feature_id
                    ].frequencies"
                    :key="freqIndex"
                    class="tw-flex tw-flex-col tw-mb-4"
                  >
                    <div class="tw-flex px-2">
                      <div class="tw-flex">
                        <div>
                          <select
                            class="demo-select tw-mx-4"
                            @change="freq.frequency = 0"
                            v-model="freq.interval"
                          >
                            <option
                              v-if="row.feature_name !== 'Reviews And Ratings'"
                              value="daily"
                            >
                              Daily
                            </option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                          </select>
                        </div>
                        <div>
                          <select
                            class="demo-select tw-mr-4"
                            v-if="freq.interval === 'weekly'"
                            v-model="freq.frequency"
                          >
                            <option value="0" disabled>Select Day</option>
                            <option value="1">Monday</option>
                            <option value="2">Tuesday</option>
                            <option value="3">Wednesday</option>
                            <option value="4">Thursday</option>
                            <option value="5">Friday</option>
                            <option value="6">Saturday</option>
                            <option value="7">Sunday</option>
                          </select>
                        </div>
                        <div
                          class="d-inline-block position-relative"
                          v-if="freq.interval === 'monthly'"
                          tabindex="0"
                          @blur="closeDateContainer"
                        >
                          <div
                            class="dateInput tw-w-[180px] tw-mr-4"
                            @click="
                              selectedFrequency[row.feature_id][
                                'isDatePickerOpen'
                              ] =
                                !selectedFrequency[row.feature_id][
                                  'isDatePickerOpen'
                                ]
                            "
                          >
                            {{ freq.frequency || "_" }}
                            of every month
                          </div>
                          <div
                            class="dateContainer position-absolute"
                            v-if="
                              selectedFrequency[row.feature_id][
                                'isDatePickerOpen'
                              ]
                            "
                          >
                            <div
                              class="d-flex justify-contents-between flex-wrap"
                            >
                              <div
                                v-for="date of 31"
                                :class="
                                  freq.frequency === date
                                    ? 'activeData'
                                    : 'datePicker'
                                "
                                class="d-flex justify-content-center mt-1 datePicker"
                                @click="freq.frequency = date"
                              >
                                <span class="py-1">{{ date }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tw-flex tw-gap-4">
                        <div class="mb-2 tw-relative tw-inline-block">
                          <vue-timepicker
                            manual-input
                            format="HH:mm"
                            v-model="freq.time"
                            :hour-range="hourRange(selectedFrequency.fix_time)"
                            :minute-range="
                              minuteRange(
                                row.feature_id,
                                selectedFrequency.fix_time,
                                freqIndex
                              )
                            "
                          />
                          <!-- <i
                            class="fa fa-close tw-p-2 tw-absolute tw-left-[-4px] tw-top-[2px] tw-transform -tw-translate-y-1/2 tw-bg-[#F4F4F4] tw-w-6 tw-h-4 tw-rounded-full tw-cursor-pointer tw-justify-center tw-flex tw-items-center"
                            @click="
                              removeTimePicker(row.feature_id, freqIndex, index)
                            "
                          ></i> -->
                        </div>
                      </div>
                      <i
                        class="fa fa-trash tw-ml-4 tw-bg-[#F4F4F4] tw-text-[red] tw-w-8 tw-h-8 tw-rounded-full tw-cursor-pointer tw-justify-center tw-flex tw-items-center"
                        @click="removeFrequency(row.feature_id, freqIndex)"
                        v-if="
                          selectedFrequency[row.feature_id].frequencies.length >
                          1
                        "
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="tw-flex">
                  <i
                    class="fa fa-solid fa-plus tw-bg-[#F4F4F4] tw-w-8 tw-h-8 tw-rounded-full tw-cursor-pointer tw-justify-center tw-flex tw-items-center"
                    @click="addFrequency(row.feature_id)"
                  ></i>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-4">
      <div class="d-flex">
        <button class="primarycolor mr-3" @click="saveSchedules">Save</button>
        <button
          class="navigationButton"
          @click="setSelectedSection(previousSection)"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Multiselect from "vue-multiselect";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  name: "Prodcuts",
  components: {
    Multiselect,
    VueTimepicker,
  },
  data() {
    return {
      isDateContainerOpen: false,
      selectedFrequency: {},
      invalidCheck: false,
      currentSectionIndex: null,
      previousSection: null,
    };
  },
  computed: {
    ...mapState("DemoStore", [
      "selectedFeatures",
      "sections",
      "selectedSection",
    ]),
  },
  mounted() {
    this.getSavedSchedules();
    this.currentSectionIndex = this.sections.indexOf(this.selectedSection);
    this.previousSection = this.sections[this.currentSectionIndex - 1];
  },
  methods: {
    ...mapActions("DemoStore", ["setDemoLoader", "setSelectedSection"]),
    hourRange(fixTime) {
      if (!fixTime || !fixTime.start_time || !fixTime.end_time) {
        return [];
      }
      const startHour = parseInt(fixTime.start_time.split(":")[0]);
      const endHour = parseInt(fixTime.end_time.split(":")[0]);
      return [startHour, [startHour + 1, endHour - 1], endHour];
    },

    minuteRange(featureId, fixTime, index) {
      // console.log("Selected Time:", this.selectedFrequency[featureId]["time"]);
      // console.log("Fix Time:", fixTime);

      if (!fixTime || !fixTime.start_time || !fixTime.end_time) {
        return Array.from({ length: 60 }, (_, i) => i);
      }

      const selectedTimes = this.selectedFrequency[featureId]["time"];
      const selectedTime = Array.isArray(selectedTimes)
        ? selectedTimes[index]
        : selectedTimes;

      const hour = selectedTime ? parseInt(selectedTime.split(":")[0]) : null;

      // console.log("Selected Hour:", hour);

      const startHour = parseInt(fixTime.start_time.split(":")[0]);
      const startMinute = parseInt(fixTime.start_time.split(":")[1]);
      const endHour = parseInt(fixTime.end_time.split(":")[0]);
      const endMinute = parseInt(fixTime.end_time.split(":")[1]);

      if (hour === null || isNaN(hour)) {
        console.warn(
          "Selected hour is missing or invalid. Allowing all minutes."
        );
        return Array.from({ length: 60 }, (_, i) => i);
      }

      if (hour === startHour) {
        const allowedMinutes = Array.from(
          { length: 60 - startMinute },
          (_, i) => startMinute + i
        );
        return allowedMinutes;
      } else if (hour === endHour) {
        const allowedMinutes = Array.from(
          { length: endMinute + 1 },
          (_, i) => i
        );
        return allowedMinutes;
      } else {
        return Array.from({ length: 60 }, (_, i) => i);
      }
    },
    closeDateContainer() {
      Object.values(this.selectedFrequency).forEach(
        (frequency) => (frequency["isDatePickerOpen"] = false)
      );
    },
    addFrequency(featureId) {
      if (!this.selectedFrequency[featureId]) {
        this.$set(this.selectedFrequency, featureId, {
          frequencies: [],
          isDatePickerOpen: false,
        });
      }

      this.selectedFrequency[featureId].frequencies.push({
        interval: "daily",
        frequency: 0,
        time: "00:00",
      });

      this.$set(this.selectedFrequency, featureId, {
        ...this.selectedFrequency[featureId],
        frequencies: [...this.selectedFrequency[featureId].frequencies],
      });
    },
    removeFrequency(featureId, freqIndex) {
      this.selectedFrequency[featureId].frequencies.splice(freqIndex, 1);
    },
    // addTimePicker(featureId, freqIndex) {
    //   if (!this.selectedFrequency[featureId].frequencies[freqIndex].time) {
    //     this.$set(
    //       this.selectedFrequency[featureId].frequencies[freqIndex],
    //       "time",
    //       []
    //     );
    //   }
    //   this.selectedFrequency[featureId].frequencies[freqIndex].time.push(null);
    // },
    removeTimePicker(featureId, freqIndex, timeIndex) {
      this.selectedFrequency[featureId].frequencies[freqIndex].time.splice(
        timeIndex,
        1
      );
    },
    getSavedSchedules() {
      this.selectedFrequency = {};
      this.setDemoLoader(true);

      const url = `/api/demo/schedule?region_id=${this.$store.state.DemoStore.selectedRegion.id}`;

      this.$http
        .get(url)
        .then((res) => {
          if (res.body.data_present && res.body.data) {
            const { time_zone, fix_time, ...featureData } = res.body.data;

            // Base object
            this.selectedFrequency = {
              time_zone,
              fix_time,
            };

            // Process API features
            Object.keys(featureData).forEach((featureId) => {
              const frequencies = featureData[featureId].map((item) => ({
                interval: item.interval ? item.interval.toLowerCase() : "daily",
                frequency: parseInt(item.frequency) || 0,
                time: Array.isArray(item.time)
                  ? item.time
                  : item.time || "00:00",
              }));

              this.$set(this.selectedFrequency, featureId, {
                frequencies,
                isDatePickerOpen: false,
              });
            });

            this.selectedFeatures.forEach((feat) => {
              if (!this.selectedFrequency[feat.feature_id]) {
                this.$set(this.selectedFrequency, feat.feature_id, {
                  frequencies: [
                    {
                      interval: "daily",
                      frequency: 0,
                      time: ["00:00"],
                    },
                  ],
                  isDatePickerOpen: false,
                });
              }
            });
          } else {
            this.selectedFrequency = {
              time_zone: "Indian Standard Time (IST)",
              fix_time: {
                start_time: "00:00",
                end_time: "23:59",
              },
            };

            this.selectedFeatures.forEach((feat) => {
              this.$set(this.selectedFrequency, feat.feature_id, {
                frequencies: [
                  {
                    interval: "daily",
                    frequency: 0,
                    time: ["00:00"],
                  },
                ],
                isDatePickerOpen: false,
              });
            });
          }

          this.setDemoLoader(false);
        })
        .catch((err) => {
          console.log("Error in fetching the saved schedules", err);
          this.setDemoLoader(false);
        });
    },
    saveSchedules() {
      this.saving = true;
      this.$nextTick(() => {
        const url = "/api/demo/schedule";
        let payload = {
          region_id: this.$store.state.DemoStore.selectedRegion.id,
        };

        let error = false;
        const { fix_time, time_zone, ...modifySelectedFrequency } =
          this.selectedFrequency;

        Object.keys(modifySelectedFrequency).forEach((featFrequency) => {
          const current = this.selectedFrequency[featFrequency];
          const frequencies = current.frequencies || [];
          let hasError = frequencies?.some((freq) => {
            if (freq.time && typeof freq.time === "object" && !Array.isArray(freq.time)) {
              freq.time = freq.time.HH + ":" + freq.time.mm;
            }
            return (
              !freq.interval ||
              !freq.time.length ||
              (freq.interval.toLowerCase() !== "daily" && !freq.frequency)
            );
          });
          if (hasError) {
            error = true;
          } else {
            payload[featFrequency] = frequencies.map((freq) => {
              const timeString = freq.time

              return {
                interval:
                  freq.interval.charAt(0).toUpperCase() +
                  freq.interval.slice(1),
                frequency: freq.frequency.toString(),
                time: timeString,
              };
            });
          }
        });

        if (error) {
          this.$bvToast.toast(`Please fill the fields for scheduling.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000,
          });
          this.saving = false;
          return;
        }

        this.setDemoLoader(true);
        this.$http
          .post(url, payload)
          .then((res) => {
            this.finalSubmit();
            this.setDemoLoader(false);
          })
          .catch((err) => {
            console.log("Error in saving scheduling frequency", err);
            this.setDemoLoader(false);
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    finalSubmit() {
      const url = `/api/demo/final_submit?region_id=${this.$store.state.DemoStore.selectedRegion.id}`;
      this.$http
        .get(url)
        .then((res) => {
          this.$bvToast.toast(`Account setup successfully.`, {
            title: "Weavr Sense",
            variant: "success",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000,
          });
        })
        .catch((err) => {
          this.$bvToast.toast(`Error in final submission.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000,
          });
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.dateContainer {
  width: 200px !important;
  border: 1px solid var(--primary_brand-60);
  border-radius: 5px;
  padding: 3px;
  z-index: 2000 !important;
  background: #fff;
  top: 110%;
  left: 4%;
  color: var(--primary_brand);
}

.datePicker {
  width: 16%;
}

.activeData {
  background-color: var(--primary_brand);
  color: #fff;
  border-radius: 5px;
}

.datePicker:hover {
  margin-top: 2px;
  cursor: pointer;
  background-color: var(--primary_brand-80);
  color: #fff;
  border-radius: 5px;
}

.dateInput {
  display: flex;
  border: 1px solid var(--primary_brand);
  border-radius: 5px;
  color: var(--primary_brand);
  font-weight: 500;
  padding: 9px 20px;
  font-size: 16px;
  margin-inline: 8px;
  cursor: default;
}

.demo-select {
  font-family: "Poppins", sans-serif;
  color: var(--primary_brand);
  background-color: transparent;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #065559 !important;
  border-radius: 5px;
}

.demo-select:focus {
  border: 1px solid #065559 !important;
  box-shadow: none !important;
  outline: none !important;
}

.demo-input {
  padding: 4px 10px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  color: var(--primary_brand);
}

.demo-input::placeholder {
  color: #919191;
  font-family: "Poppins", sans-serif;
}

.demo-input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}

.section-heading h4 {
  font-size: 18px;
  font-weight: 600;
}

.section-heading p {
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 500;
}

/* .table-scroll-wrapper {
  overflow-x: auto;
  position: relative;
  padding-bottom:80px;
} */

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins", sans-serif;
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButton:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

button.primarycolor {
  height: 35px;
  border: none !important;
  margin: 0;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

button.primarycolor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
<style lang="scss">
.vue__time-picker > input {
  border: 1px solid var(--primary_brand) !important;
  border-radius: 5px;
  height: 43px !important;
  padding: 9px 20px !important;
  font-size: 1em;
  margin-top: none !important;
  cursor: default;
}

table.demo-table {
  border-radius: 3px;
  border-spacing: 0;
  border-collapse: separate;
  border: 1px solid #d5d5d5 !important;
  overflow: hidden;
  min-width: 900px !important;
  // width: 100% !important;
  overflow-y: visible !important;

  > thead > tr > th {
    background-color: #e7eeef !important;
    padding: 16px 32px !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 600;
  }

  > tbody > tr > td {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: black !important;
  }

  // >tbody>tr>td:first-child {
  //     text-align: ;
  // }

  /* Apply a border to the right of all but the last column */
  th:not(:last-child),
  td:not(:last-child) {
    border-right: 1px solid #d5d5d5 !important;
  }

  /* Apply a border to the bottom of all but the last row */
  > thead > tr:not(:last-child) > th,
  > thead > tr:not(:last-child) > td,
  > tbody > tr:not(:last-child) > th,
  > tbody > tr:not(:last-child) > td,
  > tfoot > tr:not(:last-child) > th,
  > tfoot > tr:not(:last-child) > td,
  > tr:not(:last-child) > td,
  > tr:not(:last-child) > th,
  > thead:not(:last-child),
  > tbody:not(:last-child),
  > tfoot:not(:last-child) {
    border-bottom: 1px solid #d5d5d5 !important;
  }

  > tbody:last-child > tr > td:first-child > div:last-child {
    border-bottom: none !important;
  }
}
</style>
